const CommunityHeaderStyles = {
  container: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    width: "100%",
    flexWrap: "wrap",
    gap: "12px",
    mb: "15px",
  },
};

export default CommunityHeaderStyles;
